<div
  class="alert d-flex gap-2 align-items-center"
  [ngClass]="{
    'alert-warning': severity() === 'warning',
    'alert-primary': severity() === 'primary',
    'alert-danger': severity() === 'danger',
    'alert-info': severity() === 'info',
    'alert-success': severity() === 'success',
  }"
  [class]="class()"
>
  <ui-keenicon [name]="icon()" [class]="iconClass()"></ui-keenicon>
  <div>
    <ng-content></ng-content>
  </div>
</div>
